import { render } from "./UpgradeTableTotal.vue?vue&type=template&id=971695d6&scoped=true"
import script from "./UpgradeTableTotal.vue?vue&type=script&lang=js"
export * from "./UpgradeTableTotal.vue?vue&type=script&lang=js"

import "./UpgradeTableTotal.vue?vue&type=style&index=0&id=971695d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971695d6"]])

export default __exports__